import React, {Component} from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import LoadScreen from './LoadScreen';
import MainScreen from './MainScreen';
import ScenarioScreen from './ScenarioScreen';
import './ScreenAppearTransition.scss';

const screens = {
    load: LoadScreen,
    main: MainScreen,
    scenario: ScenarioScreen,
};

export default class App extends Component {
    state = {
        game: {
            loaded: false,
            scenario: null,
            finishedScenarios: [],
        },
    };

    getRoute() {
        const {game} = this.state;

        if (!game.loaded) {
            return 'load';
        }

        return game.scenario ? 'scenario' : 'main';
    }

    render() {
        const {game} = this.state;

        const route = this.getRoute();
        const Screen = screens[route];

        if (!Screen) {
            return null;
        }

        return (
            <ReactCSSTransitionGroup
                transitionName='screen-appear'
                transitionEnterTimeout={800}
                transitionLeaveTimeout={800}
            >
                <Screen
                    key={route}
                    game={game}
                    onChangeGame={this.handleChangeGame(route)}
                />
            </ReactCSSTransitionGroup>
        );
    }

    handleChangeGame = route => nextGame => {
        if (!this.state.game.scenario && route === 'scenario') {
            return;
        }

        this.setState({
            game: nextGame,
        });
    };
}
